import { createSelector } from '@ngrx/store';

import { selectLiveEdgeState } from './live-edge-base.selectors';

import ILiveTag = Microsoft.VideoIndexer.Live.Contracts.ILiveTag;

export const selectMediaFilesListState = createSelector(selectLiveEdgeState, state => state?.mediaFiles);

export const selectMediaFilesListEntities = createSelector(selectMediaFilesListState, state => state?.entities ?? []);
export const selectMediaFileById = (id: string) => createSelector(selectMediaFilesListEntities, entities => entities[id]);
export const selectMediaFilesList = createSelector(selectMediaFilesListState, state => Object.values(state.entities));

export const selectMediaFilesListNextPage = createSelector(selectMediaFilesListState, state => state.nextPage);
export const selectIsMediaFilesListLoaded = createSelector(selectMediaFilesListState, state => state.loaded);
export const selectsMediaFilesListLoading = createSelector(
  selectMediaFilesListState,
  selectIsMediaFilesListLoaded,
  (mediaFilesState, isMediaFilesListLoaded) => {
    return mediaFilesState.isLoading && !isMediaFilesListLoaded;
  }
);

export const selectHasMediaFilesListError = createSelector(selectMediaFilesListState, state => state.error);

export const selectCurrentCameraAllMediaFiles = createSelector(selectMediaFilesListState, state => state.currentCameraMediaFiles.mediaFiles);
export const selectCurrentCameraAllMediaFilesIsLoading = createSelector(selectMediaFilesListState, state => state.currentCameraMediaFiles.isLoading);
export const selectCurrentCameraAllMediaFilesIsLoaded = createSelector(selectMediaFilesListState, state => state.currentCameraMediaFiles.loaded);
export const selectCurrentCameraAllMediaFilesHasError = createSelector(selectMediaFilesListState, state => state.currentCameraMediaFiles.error);

export const selectIsMediaFileDeleting = createSelector(selectMediaFilesListState, state => state.isDeleting);
export const selectIsMediaFileRenaming = createSelector(selectMediaFilesListState, state => state.isRenaming);

export const selectIsInsightsTypesLoaded = (id: string) => createSelector(selectMediaFileById(id), mediaFile => mediaFile?.isInsightsTypesLoaded);

export const selectVideoTags = (mediaFileId: string) =>
  createSelector(selectMediaFileById(mediaFileId), (mediaFile): ILiveTag[] | undefined => mediaFile?.tags);

export const selectAreVideoTagsLoading = (mediaFileId: string) =>
  createSelector(selectMediaFileById(mediaFileId), (mediaFile): boolean | undefined => mediaFile?.areTagsLoading);

export const selectVideoTagsError = (mediaFileId: string) => createSelector(selectMediaFileById(mediaFileId), mediaFile => mediaFile?.tagsError);

export const selectAreVideoTagsUpdating = (mediaFileId: string) =>
  createSelector(selectMediaFileById(mediaFileId), (mediaFile): boolean | undefined => mediaFile?.areTagsUpdating);

export const selectVideoTagsUpdateError = (mediaFileId: string) =>
  createSelector(selectMediaFileById(mediaFileId), mediaFile => mediaFile?.tagsUpdateError);
